import React from 'react';
import Icon from '../../../components/AppIcon';
import { Checkbox } from '../../../components/ui/Checkbox';

const QuarterlyMilestonesSection = ({ milestones, onToggleMilestone }) => {
  return (
    <div className="bg-card rounded-xl border border-border p-6 md:p-8 elevation-sm">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-lg bg-accent/20 flex items-center justify-center">
          <Icon name="Calendar" size={20} color="var(--color-accent)" />
        </div>
        <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground">
          Quarterly Milestones
        </h3>
      </div>
      <div className="space-y-4">
        {milestones?.map((milestone, index) => (
          <div
            key={milestone?.id}
            className={`p-4 md:p-5 rounded-lg border transition-smooth ${
              milestone?.completed
                ? 'bg-success/5 border-success/20' :'bg-muted/30 border-border hover:border-primary/30'
            }`}
          >
            <div className="flex items-start gap-4">
              <Checkbox
                checked={milestone?.completed}
                onChange={() => onToggleMilestone(milestone?.id)}
                size="default"
                className="mt-1"
              />
              <div className="flex-1 min-w-0">
                <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3 mb-2">
                  <span className="text-xs font-medium text-primary font-caption px-2 py-1 bg-primary/10 rounded w-fit">
                    Q{milestone?.quarter} {milestone?.year}
                  </span>
                  <span className="text-xs text-muted-foreground font-caption">
                    {milestone?.timeframe}
                  </span>
                </div>
                <h4
                  className={`text-sm md:text-base font-medium font-body mb-2 ${
                    milestone?.completed ? 'text-success line-through' : 'text-foreground'
                  }`}
                >
                  {milestone?.title}
                </h4>
                <p className="text-sm text-muted-foreground font-body mb-3">
                  {milestone?.description}
                </p>
                <div className="flex flex-wrap gap-2">
                  {milestone?.metrics?.map((metric, idx) => (
                    <div
                      key={idx}
                      className="flex items-center gap-2 px-3 py-1.5 bg-background rounded-md"
                    >
                      <Icon name="TrendingUp" size={14} color="var(--color-muted-foreground)" />
                      <span className="text-xs text-foreground font-caption">
                        {metric}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default QuarterlyMilestonesSection;